// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewDataTab_viewDataContainer__O4\\+\\+1 {
  padding: 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 30px;
}
.ViewDataTab_viewDataContainer__O4\\+\\+1 h2 {
  text-align: center;
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 30px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_filterToggleContainer__\\+spW8 {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.ViewDataTab_filterToggleButton__SFwRX {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.ViewDataTab_filterToggleButton__SFwRX:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.ViewDataTab_filterToggleButton__SFwRX:active {
  transform: translateY(0);
}
.ViewDataTab_filterToggleButton__SFwRX.ViewDataTab_activeFilters__hF2JA {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}
.ViewDataTab_filterToggleButton__SFwRX.ViewDataTab_activeFilters__hF2JA:hover {
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.ViewDataTab_activeFilterIndicator__AqCrm {
  color: #ffc107;
  font-size: 18px;
  animation: ViewDataTab_pulse__NHeNm 2s infinite;
}

@keyframes ViewDataTab_pulse__NHeNm {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.ViewDataTab_filterToggleIcon__lcumG {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.ViewDataTab_loadingContainer__3LhM4 {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.ViewDataTab_loadingContainer__3LhM4 p {
  color: #6c757d;
  font-size: 16px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_formSelection__7oa5Q {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.ViewDataTab_formSelection__7oa5Q label {
  display: block;
  font-weight: 600;
  color: #495057;
  font-size: 16px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  margin-bottom: 10px;
}

.ViewDataTab_formSelect__MRP6N {
  width: 100%;
  padding: 12px 20px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  color: #495057;
  transition: border-color 0.3s ease;
}
.ViewDataTab_formSelect__MRP6N:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.ViewDataTab_formSelect__MRP6N option {
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_formSummary__bwt2j {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.ViewDataTab_formSummary__bwt2j h3 {
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_summaryGrid__9QtTh {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.ViewDataTab_summaryContainer__LJHuB {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
}

.ViewDataTab_summaryItem__ZjS5z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #28a745;
}

.ViewDataTab_summaryLabel__8DoYx {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_summaryValue__AG5-M {
  font-weight: 500;
  color: #2c3e50;
  font-size: 14px;
  text-align: right;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_filterControls__4GL4g {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.ViewDataTab_toggleFiltersButton__UrINn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.ViewDataTab_toggleFiltersButton__UrINn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.ViewDataTab_filtersSection__SbdO6 {
  margin-top: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.ViewDataTab_filterRow__0KcBD {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.ViewDataTab_filterGroup__5B1O1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ViewDataTab_filterGroup__5B1O1 label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_filterSelect__gkNV4 {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  cursor: pointer;
}
.ViewDataTab_filterSelect__gkNV4:focus {
  outline: none;
  border-color: #667eea;
}

.ViewDataTab_filterInput__sJN2T {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
}
.ViewDataTab_filterInput__sJN2T:focus {
  outline: none;
  border-color: #667eea;
}
.ViewDataTab_filterInput__sJN2T::placeholder {
  color: #6c757d;
}

.ViewDataTab_clearFiltersButton__v6pWv {
  padding: 8px 16px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.ViewDataTab_clearFiltersButton__v6pWv:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.ViewDataTab_filterStats__PQlny {
  margin-top: 15px;
  padding: 10px;
  background: #e9ecef;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: #495057;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_tableContainer__2H9-q {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  overflow-x: auto;
}
.ViewDataTab_tableContainer__2H9-q h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_table__rMS9O {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  min-width: 1200px;
}
.ViewDataTab_table__rMS9O th, .ViewDataTab_table__rMS9O td {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.ViewDataTab_table__rMS9O th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #000;
}
.ViewDataTab_table__rMS9O tbody tr {
  height: 40px;
  transition: background-color 0.2s ease;
}
.ViewDataTab_table__rMS9O tbody tr:hover {
  background-color: #f8f9fa;
}
.ViewDataTab_table__rMS9O thead tr:nth-child(3) {
  background-color: #e9ecef;
  font-weight: bold;
}
.ViewDataTab_table__rMS9O thead tr:nth-child(3) td {
  background-color: #e9ecef;
  font-weight: bold;
  color: #000;
}

.ViewDataTab_paginationContainer__ikl\\+B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 2px solid #e9ecef;
}

.ViewDataTab_paginationInfo__lkY3i {
  color: #6c757d;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_itemsPerPageSelect__yd8\\+7 {
  padding: 6px 10px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  cursor: pointer;
  margin-left: 10px;
}
.ViewDataTab_itemsPerPageSelect__yd8\\+7:focus {
  outline: none;
  border-color: #667eea;
}

.ViewDataTab_paginationButtons__tMYch {
  display: flex;
  gap: 10px;
}

.ViewDataTab_paginationButton__\\+RZuz {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  min-width: 40px;
}
.ViewDataTab_paginationButton__\\+RZuz:hover:not(:disabled) {
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-1px);
}
.ViewDataTab_paginationButton__\\+RZuz:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ViewDataTab_paginationButton__\\+RZuz.ViewDataTab_activePage__PQLLZ {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-color: #667eea;
}

.ViewDataTab_actionButtons__lQR0W {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 2px solid #e9ecef;
}

.ViewDataTab_actionButton__AAiCZ {
  padding: 12px 30px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}
.ViewDataTab_actionButton__AAiCZ:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}
.ViewDataTab_actionButton__AAiCZ:nth-child(2) {
  background: linear-gradient(135deg, #007bff, #0056b3);
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}
.ViewDataTab_actionButton__AAiCZ:nth-child(2):hover {
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}
.ViewDataTab_actionButton__AAiCZ:nth-child(3) {
  background: linear-gradient(135deg, #17a2b8, #138496);
  box-shadow: 0 4px 15px rgba(23, 162, 184, 0.3);
}
.ViewDataTab_actionButton__AAiCZ:nth-child(3):hover {
  box-shadow: 0 6px 20px rgba(23, 162, 184, 0.4);
}

.ViewDataTab_editFormBtn__v4MZL, .ViewDataTab_printDataBtn__LuBRC {
  padding: 12px 30px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_editFormBtn__v4MZL {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}
.ViewDataTab_editFormBtn__v4MZL:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

.ViewDataTab_printDataBtn__LuBRC {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}
.ViewDataTab_printDataBtn__LuBRC:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}

.ViewDataTab_topLevelFilters__BDNLn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 25px;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
}
.ViewDataTab_topLevelFilters__BDNLn h3 {
  color: white;
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_topFilterRow__y-DJo {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  align-items: end;
}

.ViewDataTab_topFilterGroup__TKFs3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ViewDataTab_topFilterGroup__TKFs3 label {
  color: white;
  font-size: 14px;
  font-weight: 500;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_topFilterSelect__vspqz {
  padding: 12px 15px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}
.ViewDataTab_topFilterSelect__vspqz:focus {
  outline: none;
  border-color: #fff;
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}
.ViewDataTab_topFilterSelect__vspqz:hover {
  border-color: rgba(255, 255, 255, 0.6);
}

.ViewDataTab_clearFiltersButton__v6pWv {
  padding: 12px 20px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.ViewDataTab_clearFiltersButton__v6pWv:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #ff5252, #d63031);
}
.ViewDataTab_clearFiltersButton__v6pWv:active {
  transform: translateY(0);
}

.ViewDataTab_filterSection__avY1y {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  animation: ViewDataTab_slideDown__QPWFM 0.3s ease-out;
}

@keyframes ViewDataTab_slideDown__QPWFM {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.ViewDataTab_filterHeader__Hd5Zs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e9ecef;
}
.ViewDataTab_filterHeader__Hd5Zs h3 {
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_filterCategory__2ahdL {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}
.ViewDataTab_filterCategory__2ahdL h4 {
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.ViewDataTab_filterCategory__2ahdL:last-child {
  margin-bottom: 0;
}

.ViewDataTab_filterRow__0KcBD {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}
.ViewDataTab_filterRow__0KcBD:last-child {
  margin-bottom: 0;
}

.ViewDataTab_filterGroup__5B1O1 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ViewDataTab_filterGroup__5B1O1 label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  margin-bottom: 4px;
}
.ViewDataTab_filterGroup__5B1O1 input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.ViewDataTab_filterGroup__5B1O1 input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.ViewDataTab_filterGroup__5B1O1 input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}
.ViewDataTab_filterGroup__5B1O1 input:hover {
  border-color: #adb5bd;
}

.ViewDataTab_filterStats__PQlny {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.ViewDataTab_clearFiltersButton__v6pWv {
  padding: 10px 20px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.ViewDataTab_clearFiltersButton__v6pWv:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
  background: linear-gradient(135deg, #c82333, #bd2130);
}
.ViewDataTab_clearFiltersButton__v6pWv:active {
  transform: translateY(0);
}

.ViewDataTab_tableFilters__H-\\+82 {
  margin-top: 25px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}
.ViewDataTab_tableFilters__H-\\+82 h4 {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.ViewDataTab_clearFiltersButton__v6pWv {
  padding: 10px 20px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  margin-top: 10px;
}
.ViewDataTab_clearFiltersButton__v6pWv:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

@media (max-width: 768px) {
  .ViewDataTab_viewDataContainer__O4\\+\\+1 {
    padding: 20px;
  }
  .ViewDataTab_formSelection__7oa5Q, .ViewDataTab_formSummary__bwt2j, .ViewDataTab_filterControls__4GL4g, .ViewDataTab_tableContainer__2H9-q {
    padding: 20px;
  }
  .ViewDataTab_summaryGrid__9QtTh {
    grid-template-columns: 1fr;
  }
  .ViewDataTab_filterToggleButton__SFwRX {
    padding: 10px 20px;
    font-size: 14px;
  }
  .ViewDataTab_filterSection__avY1y {
    padding: 20px;
  }
  .ViewDataTab_filterHeader__Hd5Zs {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  .ViewDataTab_filterHeader__Hd5Zs h3 {
    font-size: 1.3rem;
  }
  .ViewDataTab_filterCategory__2ahdL {
    padding: 15px;
  }
  .ViewDataTab_filterRow__0KcBD {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .ViewDataTab_filterGroup__5B1O1 input {
    padding: 10px 14px;
    font-size: 13px;
  }
  .ViewDataTab_table__rMS9O {
    min-width: 800px;
  }
  .ViewDataTab_table__rMS9O th, .ViewDataTab_table__rMS9O td {
    padding: 8px;
    font-size: 12px;
  }
  .ViewDataTab_paginationContainer__ikl\\+B {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  .ViewDataTab_actionButtons__lQR0W {
    flex-direction: column;
    gap: 15px;
  }
  .ViewDataTab_actionButton__AAiCZ {
    padding: 10px 20px;
    font-size: 14px;
    min-width: 120px;
  }
  .ViewDataTab_topFilterRow__y-DJo {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .ViewDataTab_topFilterSelect__vspqz {
    padding: 10px 12px;
    font-size: 13px;
  }
  .ViewDataTab_clearFiltersButton__v6pWv {
    padding: 10px 16px;
    font-size: 13px;
  }
  .ViewDataTab_filterStats__PQlny {
    padding: 10px 14px;
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .ViewDataTab_viewDataContainer__O4\\+\\+1 {
    padding: 15px;
  }
  .ViewDataTab_formSelection__7oa5Q, .ViewDataTab_formSummary__bwt2j, .ViewDataTab_filterControls__4GL4g, .ViewDataTab_tableContainer__2H9-q {
    padding: 15px;
  }
  .ViewDataTab_filterToggleButton__SFwRX {
    padding: 8px 16px;
    font-size: 13px;
  }
  .ViewDataTab_filterSection__avY1y {
    padding: 15px;
  }
  .ViewDataTab_filterHeader__Hd5Zs h3 {
    font-size: 1.2rem;
  }
  .ViewDataTab_filterCategory__2ahdL {
    padding: 12px;
  }
  .ViewDataTab_filterGroup__5B1O1 input {
    padding: 8px 12px;
    font-size: 12px;
  }
  .ViewDataTab_table__rMS9O {
    min-width: 600px;
  }
  .ViewDataTab_table__rMS9O th, .ViewDataTab_table__rMS9O td {
    padding: 6px;
    font-size: 11px;
  }
  .ViewDataTab_filterStats__PQlny {
    padding: 8px 12px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/ViewDataTab.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,sDAAA;AACJ;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,+CAAA;AADF;AAGE;EACE,2BAAA;EACA,+CAAA;AADJ;AAIE;EACE,wBAAA;AAFJ;AAKE;EACE,6DAAA;EACA,6CAAA;AAHJ;AAKI;EACE,6CAAA;AAHN;;AAQA;EACE,cAAA;EACA,eAAA;EACA,+CAAA;AALF;;AAQA;EACE;IACE,UAAA;EALF;EAOA;IACE,YAAA;EALF;EAOA;IACE,UAAA;EALF;AACF;AAQA;EACE,eAAA;EACA,+BAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AANF;AAQE;EACE,cAAA;EACA,eAAA;EACA,sDAAA;AANJ;;AAUA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACE,mBAAA;AAPJ;AASE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sDAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACE,sDAAA;EACF,iBAAA;EACA,cAAA;EACA,kCAAA;AARF;AAUE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AARJ;AAWE;EACE,sDAAA;AATJ;;AAaA;EACM,iBAAA;EACJ,mBAAA;EACI,aAAA;EACJ,yCAAA;EACA,mBAAA;AAVF;AAYE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACI,gBAAA;EACJ,gCAAA;EACA,oBAAA;EACI,sDAAA;AAVR;;AAcM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAXR;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,SAAA;AAXF;;AAcQ;EACE,aAAA;EACR,8BAAA;EACA,mBAAA;EACQ,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAXV;;AAcU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sDAAA;AAXZ;;AAcU;EACE,gBAAA;EACV,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACU,sDAAA;AAXZ;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAXF;AAaE;EACE,2BAAA;EACA,+CAAA;AAXJ;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACI,mBAAA;EACA,yBAAA;AAZN;;AAeA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZF;AAcE;EACM,gBAAA;EACJ,cAAA;EACA,eAAA;EACI,sDAAA;AAZR;;AAgBA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACQ,iBAAA;EACR,eAAA;AAbF;AAeE;EACE,aAAA;EACA,qBAAA;AAbJ;;AAiBA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACY,eAAA;EACA,sDAAA;EACZ,iBAAA;AAdF;AAgBE;EACE,aAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,cAAA;AAfJ;;AAmBA;EACE,iBAAA;EACA,qDAAA;EACA,YAAA;EACY,YAAA;EACZ,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAhBF;AAkBE;EACE,2BAAA;EACA,4CAAA;AAhBJ;;AAoBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sDAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sDAAA;AAjBJ;;AAqBA;EACE,yBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAlBF;AAoBE;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,sDAAA;AAlBJ;AAqBE;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AAnBJ;AAsBE;EACE,YAAA;EACU,sCAAA;AApBd;AAsBc;EACE,yBAAA;AApBhB;AAyBE;EACE,yBAAA;EACA,iBAAA;AAvBJ;AAyBI;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AAvBN;;AA4BA;EACU,aAAA;EACA,8BAAA;EACA,mBAAA;EACR,gBAAA;EACA,eAAA;EACA,6BAAA;AAzBF;;AA4BA;EACE,cAAA;EACU,eAAA;EACA,sDAAA;AAzBZ;;AA4BA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACU,sDAAA;EACV,iBAAA;EACA,eAAA;EACA,iBAAA;AAzBF;AA2BE;EACE,aAAA;EACA,qBAAA;AAzBJ;;AA6BA;EACE,aAAA;EACA,SAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,eAAA;AA1BF;AA4BE;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;AA1BJ;AA6BE;EACE,YAAA;EACA,mBAAA;AA3BJ;AA8BE;EACE,qDAAA;EACA,YAAA;EACA,qBAAA;AA5BJ;;AAgCI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACJ,gBAAA;EACA,eAAA;EACI,6BAAA;AA7BN;;AAgCA;EACE,kBAAA;EACM,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACN,gBAAA;EACM,sDAAA;EACN,qDAAA;EACA,YAAA;EACA,6CAAA;AA7BF;AA+BE;EACE,2BAAA;EACA,6CAAA;AA7BJ;AAgCE;EACE,qDAAA;EACA,6CAAA;AA9BJ;AAgCQ;EACF,6CAAA;AA9BN;AAkCE;EACE,qDAAA;EACA,8CAAA;AAhCJ;AAkCI;EACE,8CAAA;AAhCN;;AAqCA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sDAAA;AAlCF;;AAqCM;EACE,qDAAA;EACA,YAAA;EACN,6CAAA;AAlCF;AAoCQ;EACJ,2BAAA;EACA,6CAAA;AAlCJ;;AAsCM;EACE,qDAAA;EACA,YAAA;EACN,+CAAA;AAnCF;AAqCQ;EACJ,2BAAA;EACA,+CAAA;AAnCJ;;AAwCA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gDAAA;AArCF;AAuCE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sDAAA;AArCJ;;AAyCA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtCF;AAwCE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sDAAA;AAtCJ;;AA0CA;EACE,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,sDAAA;EACA,yBAAA;EACA,2BAAA;AAvCF;AAyCE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,8CAAA;AAvCJ;AA0CE;EACE,sCAAA;AAxCJ;;AA4CA;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,yBAAA;EACA,qBAAA;AAzCF;AA2CE;EACE,2BAAA;EACA,+CAAA;EACA,qDAAA;AAzCJ;AA4CE;EACE,wBAAA;AA1CJ;;AA+CA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,qDAAA;AA5CF;;AA+CA;EACE;IACE,UAAA;IACA,4BAAA;EA5CF;EA8CA;IACE,UAAA;IACA,wBAAA;EA5CF;AACF;AA+CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA7CF;AA+CE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,sDAAA;AA7CJ;;AAiDA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AA9CF;AAgDE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sDAAA;AA9CJ;AAiDE;EACE,gBAAA;AA/CJ;;AAmDA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAhDF;AAkDE;EACE,gBAAA;AAhDJ;;AAoDA;EACE,aAAA;EACM,sBAAA;EACN,QAAA;AAjDF;AAmDE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sDAAA;EACA,kBAAA;AAjDJ;AAoDE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACM,eAAA;EACN,sDAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AAlDJ;AAoDI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;EACA,2BAAA;AAlDN;AAqDI;EACE,cAAA;EACA,YAAA;AAnDN;AAsDI;EACE,qBAAA;AApDN;;AAyDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;EACA,4CAAA;AAtDF;;AAyDA;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAtDF;AAwDE;EACE,2BAAA;EACA,6CAAA;EACA,qDAAA;AAtDJ;AAyDE;EACE,wBAAA;AAvDJ;;AA2DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAxDF;AA0DE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sDAAA;AAxDJ;;AA4DA;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,gBAAA;AAzDF;AA2DE;EACE,2BAAA;EACA,6CAAA;AAzDJ;;AA8DA;EACE;IACE,aAAA;EA3DF;EA8DA;IACE,aAAA;EA5DF;EA+DA;IACE,0BAAA;EA7DF;EAgEA;IACE,kBAAA;IACA,eAAA;EA9DF;EAiEA;IACE,aAAA;EA/DF;EAkEA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAhEF;EAkEE;IACE,iBAAA;EAhEJ;EAoEA;IACE,aAAA;EAlEF;EAqEA;IACE,0BAAA;IACA,SAAA;EAnEF;EAuEE;IACE,kBAAA;IACA,eAAA;EArEJ;EAyEA;IACE,gBAAA;EAvEF;EAyEE;IACE,YAAA;IACA,eAAA;EAvEJ;EA2EA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAzEF;EA4EA;IACE,sBAAA;IACA,SAAA;EA1EF;EA6EA;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;EA3EF;EA8EA;IACE,0BAAA;IACA,SAAA;EA5EF;EA+EA;IACE,kBAAA;IACA,eAAA;EA7EF;EAgFA;IACE,kBAAA;IACA,eAAA;EA9EF;EAiFA;IACE,kBAAA;IACA,eAAA;EA/EF;AACF;AAkFA;EACE;IACE,aAAA;EAhFF;EAmFA;IACE,aAAA;EAjFF;EAoFA;IACE,iBAAA;IACA,eAAA;EAlFF;EAqFA;IACE,aAAA;EAnFF;EAuFE;IACE,iBAAA;EArFJ;EAyFA;IACE,aAAA;EAvFF;EA2FE;IACE,iBAAA;IACA,eAAA;EAzFJ;EA6FA;IACE,gBAAA;EA3FF;EA6FE;IACE,YAAA;IACA,eAAA;EA3FJ;EA+FA;IACE,iBAAA;IACA,eAAA;EA7FF;AACF","sourcesContent":[".viewDataContainer {\n  padding: 30px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 12px;\n  margin-bottom: 30px;\n\n  h2 {\n    text-align: center;\n    color: #2c3e50;\n    font-size: 2rem;\n    margin-bottom: 30px;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n// Filter Toggle Button\n.filterToggleContainer {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.filterToggleButton {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 25px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  &.activeFilters {\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n\n    &:hover {\n      box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n    }\n  }\n}\n\n.activeFilterIndicator {\n  color: #ffc107;\n  font-size: 18px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.filterToggleIcon {\n  font-size: 14px;\n  transition: transform 0.3s ease;\n}\n\n.loadingContainer {\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n\n  p {\n    color: #6c757d;\n    font-size: 16px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.formSelection {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n\n  label {\n    display: block;\n    font-weight: 600;\n    color: #495057;\n    font-size: 16px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    margin-bottom: 10px;\n  }\n}\n\n.formSelect {\n  width: 100%;\n  padding: 12px 20px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 16px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  color: #495057;\n  transition: border-color 0.3s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  }\n\n  option {\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.formSummary {\n      background: white;\n  border-radius: 15px;\n      padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n    text-align: center;\n        font-weight: 600;\n    border-bottom: 2px solid #e9ecef;\n    padding-bottom: 10px;\n        font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n      }\n\n      .summaryGrid {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n        gap: 20px;\n}\n\n.summaryContainer {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n        .summaryItem {\n          display: flex;\n  justify-content: space-between;\n  align-items: center;\n          padding: 15px;\n          background: #f8f9fa;\n          border-radius: 8px;\n          border-left: 4px solid #28a745;\n}\n\n          .summaryLabel {\n            font-weight: 600;\n            color: #495057;\n            font-size: 14px;\n            font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n          }\n\n          .summaryValue {\n            font-weight: 500;\n  color: #2c3e50;\n  font-size: 14px;\n  text-align: right;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n            font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n          }\n\n.filterControls {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.toggleFiltersButton {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  }\n}\n\n.filtersSection {\n  margin-top: 20px;\n  padding: 20px;\n  background: #f8f9fa;\n      border-radius: 10px;\n      border: 1px solid #e9ecef;\n}\n\n.filterRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  label {\n        font-weight: 600;\n    color: #495057;\n    font-size: 14px;\n        font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.filterSelect {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n          background: white;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n}\n\n.filterInput {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n              font-size: 14px;\n              font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n\n  &::placeholder {\n    color: #6c757d;\n  }\n}\n\n.clearFiltersButton {\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n              border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n  }\n}\n\n.filterStats {\n  margin-top: 15px;\n  padding: 10px;\n  background: #e9ecef;\n  border-radius: 6px;\n  text-align: center;\n  font-size: 14px;\n  color: #495057;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n}\n\n.tableContainer {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n  overflow-x: auto; // Make table horizontally scrollable\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 20px 0;\n  min-width: 1200px; // Ensure minimum width for all columns\n  \n  th, td {\n    border: 1px solid #000;\n    padding: 10px;\n    text-align: center;\n    vertical-align: middle;\n    font-size: 14px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n  \n  th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n    color: #000;\n  }\n  \n  tbody tr {\n    height: 40px;\n              transition: background-color 0.2s ease;\n\n              &:hover {\n                background-color: #f8f9fa;\n              }\n  }\n  \n  // Style for the numbered header row (१-१७)\n  thead tr:nth-child(3) {\n    background-color: #e9ecef;\n    font-weight: bold;\n    \n    td {\n      background-color: #e9ecef;\n      font-weight: bold;\n      color: #000;\n    }\n  }\n}\n\n.paginationContainer {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n  margin-top: 20px;\n  padding: 20px 0;\n  border-top: 2px solid #e9ecef;\n}\n\n.paginationInfo {\n  color: #6c757d;\n            font-size: 14px;\n            font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n          }\n\n.itemsPerPageSelect {\n  padding: 6px 10px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  font-size: 14px;\n            font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  cursor: pointer;\n  margin-left: 10px;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n}\n\n.paginationButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.paginationButton {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  background: white;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  min-width: 40px;\n\n  &:hover:not(:disabled) {\n    border-color: #667eea;\n    color: #667eea;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.activePage {\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: white;\n    border-color: #667eea;\n      }\n    }\n\n    .actionButtons {\n      display: flex;\n      justify-content: center;\n      gap: 20px;\n  margin-top: 20px;\n  padding: 20px 0;\n      border-top: 2px solid #e9ecef;\n}\n\n.actionButton {\n  padding: 12px 30px;\n        border: none;\n        border-radius: 25px;\n        font-size: 16px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n  min-width: 150px;\n        font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n  }\n\n  &:nth-child(2) {\n    background: linear-gradient(135deg, #007bff, #0056b3);\n    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n\n        &:hover {\n      box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n    }\n  }\n\n  &:nth-child(3) {\n    background: linear-gradient(135deg, #17a2b8, #138496);\n    box-shadow: 0 4px 15px rgba(23, 162, 184, 0.3);\n    \n    &:hover {\n      box-shadow: 0 6px 20px rgba(23, 162, 184, 0.4);\n    }\n  }\n}\n\n.editFormBtn, .printDataBtn {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 25px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 150px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n}\n\n      .editFormBtn {\n        background: linear-gradient(135deg, #007bff, #0056b3);\n        color: white;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n\n        &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n        }\n      }\n\n      .printDataBtn {\n        background: linear-gradient(135deg, #6c757d, #495057);\n        color: white;\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n\n        &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);\n  }\n}\n\n// Top-level form filters\n.topLevelFilters {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 25px;\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);\n\n  h3 {\n    color: white;\n    margin: 0 0 15px 0;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.topFilterRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  align-items: end;\n}\n\n.topFilterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.topFilterSelect {\n  padding: 12px 15px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.95);\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n\n  &:focus {\n    outline: none;\n    border-color: #fff;\n    background: white;\n    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n  }\n\n  &:hover {\n    border-color: rgba(255, 255, 255, 0.6);\n  }\n}\n\n.clearFiltersButton {\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);\n    background: linear-gradient(135deg, #ff5252, #d63031);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n// Enhanced Filter Section Styles\n.filterSection {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.filterHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e9ecef;\n\n  h3 {\n    color: #2c3e50;\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.filterCategory {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n\n  h4 {\n    color: #495057;\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin: 0 0 15px 0;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #dee2e6;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.filterRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.filterGroup {\n  display: flex;\n        flex-direction: column;\n  gap: 8px;\n\n  label {\n    font-weight: 600;\n    color: #495057;\n    font-size: 14px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    margin-bottom: 4px;\n  }\n\n  input {\n    padding: 12px 16px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n          font-size: 14px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    background: white;\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      transform: translateY(-1px);\n    }\n\n    &::placeholder {\n      color: #6c757d;\n      opacity: 0.7;\n    }\n\n    &:hover {\n      border-color: #adb5bd;\n    }\n  }\n}\n\n.filterStats {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n}\n\n.clearFiltersButton {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n    background: linear-gradient(135deg, #c82333, #bd2130);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.tableFilters {\n  margin-top: 25px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n\n  h4 {\n    color: #2c3e50;\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    text-align: center;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.clearFiltersButton {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  margin-top: 10px;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .viewDataContainer {\n    padding: 20px;\n  }\n\n  .formSelection, .formSummary, .filterControls, .tableContainer {\n    padding: 20px;\n  }\n\n  .summaryGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .filterToggleButton {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n\n  .filterSection {\n    padding: 20px;\n  }\n\n  .filterHeader {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n\n    h3 {\n      font-size: 1.3rem;\n    }\n  }\n\n  .filterCategory {\n    padding: 15px;\n  }\n\n  .filterRow {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .filterGroup {\n    input {\n      padding: 10px 14px;\n      font-size: 13px;\n    }\n  }\n\n  .table {\n    min-width: 800px;\n\n    th, td {\n      padding: 8px;\n      font-size: 12px;\n    }\n  }\n\n  .paginationContainer {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .actionButtons {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .actionButton {\n    padding: 10px 20px;\n    font-size: 14px;\n    min-width: 120px;\n  }\n\n  .topFilterRow {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .topFilterSelect {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .clearFiltersButton {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n  .filterStats {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .viewDataContainer {\n    padding: 15px;\n  }\n\n  .formSelection, .formSummary, .filterControls, .tableContainer {\n    padding: 15px;\n  }\n\n  .filterToggleButton {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n\n  .filterSection {\n    padding: 15px;\n  }\n\n  .filterHeader {\n    h3 {\n      font-size: 1.2rem;\n    }\n  }\n\n  .filterCategory {\n    padding: 12px;\n  }\n\n  .filterGroup {\n    input {\n      padding: 8px 12px;\n      font-size: 12px;\n    }\n  }\n\n  .table {\n    min-width: 600px;\n\n    th, td {\n      padding: 6px;\n      font-size: 11px;\n    }\n  }\n\n  .filterStats {\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewDataContainer": `ViewDataTab_viewDataContainer__O4++1`,
	"filterToggleContainer": `ViewDataTab_filterToggleContainer__+spW8`,
	"filterToggleButton": `ViewDataTab_filterToggleButton__SFwRX`,
	"activeFilters": `ViewDataTab_activeFilters__hF2JA`,
	"activeFilterIndicator": `ViewDataTab_activeFilterIndicator__AqCrm`,
	"pulse": `ViewDataTab_pulse__NHeNm`,
	"filterToggleIcon": `ViewDataTab_filterToggleIcon__lcumG`,
	"loadingContainer": `ViewDataTab_loadingContainer__3LhM4`,
	"formSelection": `ViewDataTab_formSelection__7oa5Q`,
	"formSelect": `ViewDataTab_formSelect__MRP6N`,
	"formSummary": `ViewDataTab_formSummary__bwt2j`,
	"summaryGrid": `ViewDataTab_summaryGrid__9QtTh`,
	"summaryContainer": `ViewDataTab_summaryContainer__LJHuB`,
	"summaryItem": `ViewDataTab_summaryItem__ZjS5z`,
	"summaryLabel": `ViewDataTab_summaryLabel__8DoYx`,
	"summaryValue": `ViewDataTab_summaryValue__AG5-M`,
	"filterControls": `ViewDataTab_filterControls__4GL4g`,
	"toggleFiltersButton": `ViewDataTab_toggleFiltersButton__UrINn`,
	"filtersSection": `ViewDataTab_filtersSection__SbdO6`,
	"filterRow": `ViewDataTab_filterRow__0KcBD`,
	"filterGroup": `ViewDataTab_filterGroup__5B1O1`,
	"filterSelect": `ViewDataTab_filterSelect__gkNV4`,
	"filterInput": `ViewDataTab_filterInput__sJN2T`,
	"clearFiltersButton": `ViewDataTab_clearFiltersButton__v6pWv`,
	"filterStats": `ViewDataTab_filterStats__PQlny`,
	"tableContainer": `ViewDataTab_tableContainer__2H9-q`,
	"table": `ViewDataTab_table__rMS9O`,
	"paginationContainer": `ViewDataTab_paginationContainer__ikl+B`,
	"paginationInfo": `ViewDataTab_paginationInfo__lkY3i`,
	"itemsPerPageSelect": `ViewDataTab_itemsPerPageSelect__yd8+7`,
	"paginationButtons": `ViewDataTab_paginationButtons__tMYch`,
	"paginationButton": `ViewDataTab_paginationButton__+RZuz`,
	"activePage": `ViewDataTab_activePage__PQLLZ`,
	"actionButtons": `ViewDataTab_actionButtons__lQR0W`,
	"actionButton": `ViewDataTab_actionButton__AAiCZ`,
	"editFormBtn": `ViewDataTab_editFormBtn__v4MZL`,
	"printDataBtn": `ViewDataTab_printDataBtn__LuBRC`,
	"topLevelFilters": `ViewDataTab_topLevelFilters__BDNLn`,
	"topFilterRow": `ViewDataTab_topFilterRow__y-DJo`,
	"topFilterGroup": `ViewDataTab_topFilterGroup__TKFs3`,
	"topFilterSelect": `ViewDataTab_topFilterSelect__vspqz`,
	"filterSection": `ViewDataTab_filterSection__avY1y`,
	"slideDown": `ViewDataTab_slideDown__QPWFM`,
	"filterHeader": `ViewDataTab_filterHeader__Hd5Zs`,
	"filterCategory": `ViewDataTab_filterCategory__2ahdL`,
	"tableFilters": `ViewDataTab_tableFilters__H-+82`
};
export default ___CSS_LOADER_EXPORT___;
